import { linkRegex } from '@constants/validation';

export const isValidLink = (value: string) => {
  return linkRegex.test(value);
};
